import autoBind from "auto-bind";

class EventConnector {
  constructor() {
    autoBind(this);

    this.subscriber = null;
    this.bufferedEvents = [];
  }

  // Drain the event buffer.
  publishEvents() {
    if (this.subscriber) {
      for (let e of this.bufferedEvents) {
        this.subscriber(e);
      }

      this.bufferedEvents = [];
    }
  }

  // Add a new event to the buffer.
  trigger(e) {
    this.bufferedEvents.push(e);
    this.publishEvents();
  }

  // Update our subscriber.
  subscribe(fn) {
    this.subscriber = fn;
    this.publishEvents();
  }
}

export default EventConnector;
